import { createTranslatedText, useTranslateDeclension } from '@dreryk/react-common';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { PrescriptionTextValue } from '../PrescriptionTextValue';

type MedicineSufficientForTextValueProps = {
   readonly medicineSufficiencyCount: number | undefined;
};

export const MedicineSufficientForTextValue = (props: MedicineSufficientForTextValueProps): JSX.Element => {
   const count = props.medicineSufficiencyCount ?? 0;
   const sufficientDaysCountSuffix = useTranslateDeclension(
      count,
      prescriptionTranslationKeys.day,
      prescriptionTranslationKeys.days,
      prescriptionTranslationKeys.days
   );
   return (
      <PrescriptionTextValue
         testId={'medicineSufficientFor'}
         label={prescriptionTranslationKeys.medicineSufficientFor}
         value={createTranslatedText(
            props.medicineSufficiencyCount ? `${count} ${sufficientDaysCountSuffix}` : undefined
         )}
      />
   );
};
